module.exports = {
  language: {
    name: '中文'
  },
  headerData: [
    {
      id: 1,
      navName: 'ABOUT US',
      navProperty: [
        { id: 11, propertyName: 'OVERVIEW', href: '/aboutUs/overview' },
        { id: 12, propertyName: 'OUR PEOPLE', href: '/aboutUs/people' },
        { id: 13, propertyName: 'HISTORY', href: '/aboutUs/history' },
        { id: 14, propertyName: 'AWARDS', href: '/aboutUs/awards' }
      ]
    },
    {
      id: 2,
      navName: 'BUSINESSES',
      navProperty: [
        { id: 21, propertyName: 'PREMIUM AUTO BRANDS', href: '/business/premium-auto-brands' },
        { id: 22, propertyName: 'NEW CARS', href: '/business/new-car-sales' },
        { id: 23, propertyName: 'PRE-OWNED CARS', href: '/business/used-car-sales' },
        { id: 24, propertyName: 'AFTERSALES', href: '/business/aftersales-services' },
        { id: 25, propertyName: 'FINANCING & INSURANCE', href: '/business/financing-and-insurance' }
      ]
    },
    { id: 3, navName: 'NETWORK', href: '/network' },
    { id: 4, navName: 'CORPORATE RESPONSIBILITY', href: '/responsibility' },
    { id: 5, navName: 'CAREERS', href: '/career' },
    { id: 6, navName: 'NEWS', href: '/news' },
    { id: 7, navName: 'CONTACT', href: '/contact' }
  ],
  footerData: {
    company: 'Copyright © 2023 LSH Auto (China) Management Co. Ltd.',
    companyTwo: 'All rights reserved.',
    companyICP: '京ICP备15023982号-5',
    website: [
      { id: 1, propertyName: 'Disclaimer', href: '/disclaimer' },
      { id: 2, propertyName: 'Privacy', href: '/privacy' },
      { id: 3, propertyName: 'Sitemap', href: '/sitemap' }
      // { id: 4, propertyName: '二手车线上展厅', href: 'https://ucc.lshauto.com.cn/home' }
    ],
    footerRecord: [
      {
        id: 1,
        navName: 'ABOUT US',
        navProperty: [
          { id: 11, propertyName: 'Overview', href: '/aboutUs/overview' },
          { id: 12, propertyName: 'Our People', href: '/aboutUs/people' },
          { id: 13, propertyName: 'History', href: '/aboutUs/history' },
          { id: 14, propertyName: 'Awards', href: '/aboutUs/awards' },
        ]
      },
      {
        id: 2,
        navName: 'BUSINESSES',
        navProperty: [
          { id: 21, propertyName: 'Premium Auto Brands', href: '/business/premium-auto-brands' },
          { id: 22, propertyName: 'New Cars', href: '/business/new-car-sales' },
          { id: 23, propertyName: 'Pre-Owned Cars', href: '/business/used-car-sales' },
          { id: 24, propertyName: 'Aftersales', href: '/business/aftersales-services' },
          { id: 25, propertyName: 'Financing & Insurance', href: '/business/financing-and-insurance' }
        ]
      },

    ],
    footerTitle:[
      { id: 31, propertyName: 'NETWORK', href: '/network' },
      { id: 32, propertyName: 'CORPORATE RESPONSIBILITY', href: '/responsibility' },
      { id: 33, propertyName: 'CAREERS', href: '/career' },
      { id: 34, propertyName: 'NEWS', href: '/news' },
      { id: 35, propertyName: 'CONTACT', href: '/contact' },
    ],
  },
  notFound:{
    title:"Page Not Found",
    text:"The page you were looking for could not be found. It might have been removed, renamed, or did not exist in the first place.",
  },
  // 联系我们
  contact: {
    hideText: 'CONTACT US',
    title: 'LSH AUTO CHINA HEADQUARTERS',
    address: 'Address:',
    phone: 'Phone:',
    phoneInfo: '(+86) 10 8477 8000',
    time:'',
    timeInfo:'Business hours: Mon-Fri  9:00-18:00',
    email: 'Email:',
    emailInfo: 'info.autocn@lsh.com',
    addressCompony: 'Lei Shing Hong Auto (China) Management Co., Ltd.',
    addressSouth1: 'No. 8 Guangshun Avenue South, Bldg 3 3rd floor, Block G/H, LSH Center Chaoyang District, Beijing 100102',
    addressSouth2:'PR China',
    addressCenter: '',
    mapData: {
      mapTitle: 'Lei Shing Hong Auto (China)',
      mapCompany: 'Lei Shing Hong Auto (China) Management Co., Ltd.',
      mapAddress: '3rd Floor, Block G/H, Building 3, Lei Shing Hong Center,8 Guangshun South Street, Chaoyang District, Beijing 100102',
      mapZipCode: ''
    }
  },
  // 新闻中心
  newCenter: {
    hideText: 'NEWS',
    releaseTime: 'Filter By Year',
    queryMore: 'View more',
    prev: 'Previous News',
    next: 'Next News',
    goUp: 'ALL NEWS'
  },
  // 职业发展
  careerDev: {
    hideText: 'JOIN OUR FAMILY',
    descriptionInfo: 'LSH Auto China is the employer of choice for over 17,000 employees.',
    descriptionInfotwo: 'We are looking for dynamic individuals who are passionate about cars and aspire to contribute to the society and make a difference in LSH Auto China.',
    title: 'WHY LSH AUTO CHINA?',
    subtitleLeft: 'Industry Characteristics',
    descripLeft: 'LSH Auto China focuses on automobile distribution and maintenance services of premium luxury brands to create a professionally efficient, comprehensively sophisticated and considerate service experience by adhering to the service concept of “YOU COME FIRST, ALWAYS”. We bring together people who are passionate about and proficient in automobiles to serve our valued customers.',
    descripLeft1:'',
    descripLeft2: 'LSH Auto China focuses on automobile distribution and maintenance services of premium luxury brands to create a professionally efficient, comprehensively sophisticated and considerate service experience by adhering to the service concept of “YOU COME FIRST, ALWAYS”. We bring together people who are passionate about and proficient in automobiles to serve our valued customers.',
    descripLeft3:'',
    subtitleRight: 'Corporate Culture',
    subbottomtitleLeft: 'Career Platform',
    descripbottomLeft: 'LSH Auto China has more than 223 outlets in 87 cities across China, and its multi-brand business lines constitute a big stage for employees\' career development. We have a well-functioned system for talent training and selection.',
    subbottomtitleRight: 'Compensation & Benefits',
    descripbottomRight: 'We provide employees with diversified salaries with market competitiveness, including fixed salary, performance bonus and long-term incentive. We also provide employees with social security, housing provident fund and other benefits, such as paid annual leave and holiday care.',
    descripRight: 'We advocate an efficient corporate culture, encourage employees to keep learning with an open mindset, and actively develop their professional skills and leadership. Follow the concept of innovation to become a better you.',
    inner: 'Join Us',
    readMore:'READ MORE',
    readmoreText:'Follow wechat official account "lsh_zhaopin" for more information',
    mail: 'hr-career.autocn@lsh.com'
  },
  // 企业责任
  BusResponse: {
    hideText: 'CORPORATE RESPONSIBILITY',
    headTitle: 'GIVING BACK',
    headTitleTwo: ' TO COMMUNITIES',
    description: 'LSH Auto China firmly believes in supporting and giving back to the communities which we serve.',
    descripDetail: 'One of our major CSR activities is the Hope School initiative. The first Hope School we sponsored was built in 2007. To date, we have helped build and donated to 35 Hope Schools in China, which have benefited more than 10,000 school-going children. Our dealership General Managers have also been appointed as the honorary principals of the Hope Schools in their region.',
    headUnderline: 'SHINING STARS IN CSR',
    publicWelfare: {
      title: 'Care Packages Initiative For The COVID-19 Pandemic',
      introduction: 'LSH Auto China partnered with the Beijing Youth Development Foundation to support the medical heroes who are fighting COVID-19 in the city.'
    },
    honor: {
      title: 'CSR Recognitions',
      introduction: 'In 2017, LSH Auto China received the prestigious recognition of "Most Influential Enterprise Brand in the Chinese Automobile Industry" and “Public Welfare Contribution” by the China Automobile Dealers Association.'
    },
    summerCamp: {
      title: 'Charity Summer Camp',
      introduction: 'From July 12th to 17th, 2015, the first Lei Shing Hong Auto Hope School Public Welfare Summer Camp was held in Beijing. More than 100 children from Hope School built with the aid of Lei Shing Hong Auto gathered in Beijing.'
    },
    sliderItemList: [
      {
        title: 'Care Packages Initiative For The COVID-19 Pandemic',
        introduction: 'LSH Auto China partnered with the Beijing Youth Development Foundation to support the medical heroes who are fighting COVID-19 in the city.',
        url: 'firstSlide.jpg'
      },
      {
        title: 'CSR Recognitions',
        introduction: 'In 2017, LSH Auto China received the prestigious recognition of "Most Influential Enterprise Brand in the Chinese Automobile Industry" and “Public Welfare Contribution” by the China Automobile Dealers Association.',
        url: 'twoSlide.jpg'
      },
      {
        title: 'Charity Summer Camp',
        introduction: 'From July 12th to 17th, 2015, the first Lei Shing Hong Auto Hope School Public Welfare Summer Camp was held in Beijing. More than 100 children from Hope School built with the aid of Lei Shing Hong Auto gathered in Beijing.',
        url: 'threeSlide.jpg'
      }
    ]
  },
  // 经销网络
  SellNetwork: {
    hideText: 'NETWORK',
    findDealer: 'Dealer Search',
    searchDealer: 'Find an Outlet'
  },
  // 业务介绍-豪华汽车品牌
  luxuryCarBrand: {
    bannerTitle: 'PREMIUM AUTO BRANDS',
    sectionTitleOne: '',
    sectionTitle: 'MAIN DEALER GROUP IN PREMIUM AUTOMOTIVE RETAILING',
    centralContent: 'LSH Auto China, exclusively serving the premium automotive sector, has a presence across 87 cities. With three decades of development and experience, we maintain a robust portfolio of premium automotive brands and associated services, providing tailored experiences to continually exceed our customers’ expectations.',
    upper: {
      leftTitle: 'Strong Footprint',
      leftInfo: "We hold a first-mover advantage in key cities and have a place in fast-moving markets.",
      rightTitle: 'Good Customer Experience',
      rightInfo: 'Delivering good customer experience is one of our missions.'
    },
    lower: {
      leftTitle: 'Innovative Products and Services',
      leftInfo: 'We strive to provide personalized offerings to customers through continuous innovation.'
    },
    textColumn: 'Our commitment to our partners and recognition from customers has propelled LSH Auto China to become one of the main dealer groups for Mercedes-Benz cars. This close partnership has enabled LSH Auto China to deliver customer service in a truly exceptional way.'
  },
  // 业务介绍-新车销售
  newCarSales: {
    bannerTitle: 'NEW CARS',
    sectionTitle: 'HERITAGE',
    and: '',
    excellentTitle: '',
    centralContent: 'With a heritage and development of three decades, LSH Auto China remains at the forefront of premium automotive retailing. Our annual new car sales have exceeded 100,000 units since 2015.',
    upper: {
      leftTitle: 'Brand Coverage',
      leftInfo: 'We are dealers of Mercedes-Benz, Mercedes-AMG, Mercedes-Maybach, Mercedes-EQ and smart.',
      rightTitle: 'Extensive Sales Network',
      rightInfo: 'Our network covers 223 outlets (including convenient service satellites) across 87 cities throughout China.'
    },
    lower: {
      leftTitle: 'One-stop Service',
      leftInfo: 'We provide convenient one-stop services for new car sales.',
      rightTitle: 'Digitalized In-Store Experience',
      rightInfo: 'Fully-featured facilities coupled with a passionate and professional service team enable a digitalized experience.'
    }
  },
  // 业务介绍-二手车
  usedCarSales: {
    bannerTitle: 'Used cars',
    sectionTitleOne: 'QUALITY WITHOUT COMPROMISE',
    sectionTitle: '',
    sectionTitleTwo: '',
    centralContent: 'We first obtained the Mercedes-Benz Certified authorized dealer status in 2014, offering Mercedes-Benz Certified Pre-Owned cars.',
    upper: {
      leftTitle: 'Network coverage',
      leftInfo: ['140 dealerships','14 LSH Used Car Centers','Across 83 cities in the country'],
      centerTitle: 'Enriched car source ',
      centerInfo: ['Brands including Mercedes-Benz, etc.', 'At your choice'],
      rightTitle: 'One-stop service',
      rightInfo: ['Evaluation, inspection, preparation,','maintenance, repair']
    },
    lower: {
      leftTitle: 'Easy car purchase',
      leftInfo: ['Installment payment plan','Insurance service'],
      centerTitle: 'LSH Certification',
      centerInfo: ['17 categories, 158 standards', '1 year/ 20,000 km warranty'],
      rightTitle: 'Professional crew',
      rightInfo: ['Professional maintenance and repair team' ,'Providing technical support']
    },
    online: {
      title: 'LSH Used Car Online Showroom',
      text: "LSH Used Car Online Showroom offers an extensive range of pre-owned cars, provides a secure and convenient shopping experience, and holds diversified activities for customers. "

    }
  },
  // 业务介绍-售后服务
  afterServices: {
    bannerTitle: 'AFTERSALES',
    sectionTitleOne: 'EXPERTS',
    sectionTitle: ' IN AFTERSALES SERVICES',
    centralContent: 'With high-quality facilities meeting the Mercedes-Benz standards and a capable team of aftersales experts, LSH Auto China strives to provide professional and personalized services to meet the requirement of our customers. We maintain a distinguished track record in the Mercedes-Benz Techmasters competition, winning numerous team and individual awards over the past years. We introduce the Technical Engineer programs to ensure all repair works meet stringent quality standards.',
    upper: {
      leftTitle: 'Maintenance and Repair',
      leftInfo: 'Our certified aftersales staff provides high-quality maintenance and repair services.',
      rightTitle: 'Emergency Assistance and Insurance Claims Services',
      rightInfo: 'We offer timely emergency assistance and one-stop insurance claims and repair services.'
    },
    lower: {
      leftTitle: 'Parts and Accessories',
      leftInfo: 'We provide a wide range of parts and accessories to suit individual needs.',
      rightTitle: 'Aftermarket Services',
      rightInfo: 'Our aftermarket portfolio includes warranty extension, car grooming services and other derivative products and services.'
    }
  },
  // 业务介绍-金融保险服务
  financEInsurance: {
    bannerTitle: 'Financial & insurance services',
    sectionTitleOne: 'TAILORED',
    sectionTitle: ' SOLUTIONS',
    centralContent: 'Customers are the core of our business. To meet the individual requirements of our customers, we offer a diverse portfolio of financing and insurance products and services in partnership with various established institutions.',
    upper: {
      leftTitle: 'Diversified Channels',
      leftInfo: 'We work closely with various partners to provide diverse purchasing channels.',
      rightTitle: 'Wide Range of Products and Services',
      rightInfo: 'Customers can select products and services that meet their individual needs.'
    }
  },
  // 关于我们-企业荣誉
  compAwards: {
    bannerTitle: 'AWARDS',
    slickListChCompet: [
      {
        id: 31,
        title: 'LSH Awarded the 4 “Best Team Work” Awards, 7 “Best Individual” Awards, and 5 teams from LSH Auto China entered the final 12.',
        date: '2021',
        grantedBy: 'Awarded By Mercedes-Benz',
        url: 'chComptOne1.png'
      },
      {
        id: 32,
        title: 'LSH WON 6 TEAM AWARDS AND 9 INDIVIDUAL AWARDS IN SKILLS AND BODY&PAINT CATEGORY',
        date: '2020',
        grantedBy: 'Awarded By Mercedes-Benz',
        url: 'chComptOne.png'
      },
      {
        id: 33,
        title: 'LSH WON THE CHAMPION, THE 2ND PLACE AND THE 3RD PLACE OF ‘BEST TEAM WORK’AWARDS AND INDIVIDUAL AWARDS',
        // titleTwo: 'group awards and 4 individual best',
        // titleThree: 'awards in the skill master competition',
        date: '2019',
        grantedBy: 'Awarded By Mercedes-Benz',
        url: 'chComptTwo.jpg'
      }
    ],
    slickListMasters: [
      {
        id: 11,
        title: 'LSH won 2 of 3 Excellence Team Awards and 9 Individual Awards, and 1 Best Cohesion Award & 10 Professional Awards',
        date: '2021',
        grantedBy: 'Awarded By Mercedes-Benz',
        url: 'mastersThree.png'
      },
      {
        id: 12,
        title: 'LSH WON 2 EXCELLENCE TEAM AWARDS AND 5 WINNERS INDIVIDUAL AWARDS, IN ADDITION, LSH SALES TEAM WON 1 SALES ELITE AWARD, 10 PROFESSIONAL AWARDS & INNOVATION AWARDS',
        date: '2019',
        grantedBy: 'Awarded By Mercedes-Benz',
        url: 'mastersOne.jpg'
      },
      {
        id: 13,
        title: 'LSH WON 3 INDIVIDUAL CHAMPIONSHIPS, 6 INDIVIDUAL ALL-AROUND CHAMPIONSHIPS AND 1 DEALER GROUP CHAMPION',
        date: '2017',
        grantedBy: 'Awarded By Mercedes-Benz',
        url: 'mastersTwo.jpg'
      }
    ],
    slickListSure: [
      {
        id: 1,
        title: "CHINA AUTO DEALERS TOP Five",
        date: '2009-2023',
        grantedBy: '',
        grantedByBr: '',
        url: 'upOne.png'
      },
      {
        id: 2,
        title: 'MOST INFLUENTIAL AUTO DEALER BRAND',
        date: '2011-2022',
        grantedBy: '',
        grantedByBr: '',
        url: 'upTwo.jpg'
      },
      {
        id: 3,
        title: 'CSR CONTRIBUTION',
        date: '2011-2025',
        grantedBy: '',
        grantedByBr: '',
        url: 'upThree.jpg'
      }
    ],
    chinaCompetition: {
      benz: 'Mercedes-Benz',
      chCompetition: ' NATIONAL TECHMASTERS COMPETITION',
      description: 'Our aftersales teams have consistently outperformed the competition.'
    },
    skillMasters: {
      benz: 'MERCEDES-BENZ',
      master: ' SALES MASTER CHAMPION COMPETITION',
      description: 'Our sales elites come back with glory.'
    },
    industryAffirmation: {
      industry: 'Industry ',
      sure: 'AWARDS',
      description: 'LSH Auto China has received numerous recognitions from the industry association, the China Automobile Dealers Association, for our outstanding performance and contributions to the industry and society.'
    }
  },
  // 关于我们-我们的历史
  ouerHistory: {
    bannerTitle: 'OUR HISTORY',
    start: 'Start',
    textLeftUp: 'We started our journey in China in 1993 as a regional distributor and retailer of Mercedes-Benz cars. Our first outlet was established in Shanghai in the same year, and has the distinction of being the first authorized Mercedes-Benz outlet in the Chinese mainland.',
    textLeftDown:'This was followed by dealerships in key cities such as Beijing (1994), Qingdao (1996) and Xiamen (1997).',
    textRightUp:'As of December 2022, continued expansion has extended our footprint to cover 223 outlets (including convenient service satellites) across 87 cities.',
    textRightDown:'LSH Auto China is committed to enriching communities through numerous CSR activities. Partnering with the Hope School initiative, we helped to build the first LSH Hope School in 2007. As of 2022, 33 Hope Schools have been established, benefiting over 10,000 children.',
    timelineList: [
      {
        id: 1,
        activeClass: 'photo1993',
        time: 1993,
        title: 'Entering the Chinese mainland',
        detail: 'LSH Auto China started operations in the Chinese mainland with the first outlet being set up in Shanghai.'
      },
      {
        id: 2,
        activeClass: 'photo1994',
        time: 1994,
        title: 'First Outlet in Beijing',
        detail: 'Seizing the opportunity to gain a foothold in China’s capital city, we established our first outlet in Beijing.'
      },
      {
        id: 3,
        activeClass: 'photo2007',
        time: 2007,
        title: 'First LSH Hope School Established',
        detail: 'The first LSH Auto China Hope School we sponsored, as part of our commitment towards corporate social responsibility, was built.'
      },
      {
        id: 4,
        activeClass: 'photo2008',
        time: 2008,
        title: 'Establishment of Training Academy',
        detail: 'LSH Auto China Training Academy was established.'
      },
      {
        id: 5,
        activeClass: 'photo2010',
        time: 2010,
        title: "Top Five Auto Dealer Group",
        detail: 'LSH Auto China has been officially ranked as one of the Top Five Dealer Groups by the China Automobile Dealers Association for thirteen consecutive years.'
      },
      {
        id: 6,
        activeClass: 'photo2013',
        time: 2013,
        title: 'The first LSH Auto Center was launched in Beijing',
        detail: 'The first LSH Auto Center was launched in Beijing, comprising a full-fledged 4S dealership and Body & Paint Center.'
      },
      {
        id: 7,
        activeClass: 'photo2015',
        time: 2015,
        title: "The annual new car sales exceeding 100,000",
        detail: 'Annual new car sales exceeded 100,000 units for the first time.'
      },
      {
        id: 8,
        activeClass: 'photo2018',
        time: 2018,
        title: "First MAR2020 Showroom in China",
        detail: "The first MAR2020 Showroom in China (LSH Beijing Star) was built, offering a good in-store experience to customers."
      },
      {
        id: 9,
        activeClass: 'photo2019',
        time: 2019,
        title: "LSH Used Car Center was established",
        detail: "The first LSH Used Car Center was officially established in Dalian."
      },
      {
        id: 10,
        activeClass: 'photo20221',
        time: 2022,
        title: "The world's"+' first "Mercedes-Maybach Atelier"',
        detail: "LSH Auto China opens the world’s first Maybach Atelier in Shanghai."
      },
      // {
      //   id: 11,
      //   activeClass: '',
      //   time: "",
      //   title: '',
      //   detail: ''
      // },
      // {
      //   id: 12,
      //   activeClass: 'photo20222',
      //   time: "",
      //   title: 'LSH Auto China teams up with the renewed smart brand',
      //   detail: 'The network includes 4 cities and 18 service outlets for the brand debut.'
      // }
    ],
    future: 'Future'
  },
  // 关于我们-我们的团队
  ouerPeople: {
    bannerTitle: 'OUR PEOPLE',
    innerTitle: 'Our people are our valuable assets.',
    innerDetail: 'The innovation and dedication of our 17K+ employees underpin our business operations and deliver the competitive advantage that drives our success.',
    ProfessionalTraining: 'Established Training Platforms',
    professionalTrainingDetail: 'LSH Auto China Training Academy was established in 2008 to cultivate future leaders and develop human capital for long-term business sustainability. With a comprehensive training system in place, our Training Academy offers face-to-face, online and mobile learning platforms, as well as other learning channels. All our instructors are equipped with a wealth of theoretical knowledge and practical experience.',
    outstandingTalents: 'Qualified Personnel',
    outstandingTalentsDetail: 'LSH Auto China always attaches importance to talent selection, training and development. We have requirements for qualification, and professional certification of key positions. Having a high-quality team fully reflects another high-quality standard of LSH Auto China. The professional quality and skill of our employees win very high recognition and enjoy high reputations in the industry.',
    awards: 'Achievements',
    awardsDetail: 'Our team have been winners of numerous awards given out by Mercedes-Benz, the dealer association body as well as other professional bodies. We are especially proud of our stellar track record in the Mercedes-Benz Techmasters competition, where our technicians have consistently outshined the competition, gaining accolades at both national and global stage.',
    MoreAwardsDetail: 'See more of our',
    serviceIdea: 'OUR SERVICE DNA',
    serviceIdeaDetail: 'At LSH Auto China, we know the importance of building a trusted relationship with our customers. To build and maintain this relationship, we strive to deliver a delightful experience through a service brand that is unique to us. It is in our DNA to serve our customers sincerely, professionally and with a personal touch.',
    passionAndIntention: '<span style="font-weight: 300;"></span> <strong>SERVING WITH PASSION</strong>',
    wholeheartedly: 'We are passionate about what we do.',
    wholeheartedlyUnderline: "With a culture that is open, transparent and performance-driven, our employees are deeply engaged and committed to delivering high-quality experiences. In the 2021 Mercedes-Benz Dealer’s Employee Engagement Survey, LSH Auto China scored the highest ratings among all Mercedes-Benz dealer groups in China.",
    wholeheartedlyText: 'We have employees that have been with us for many years, some since the inception of our business. These experienced staffs have inherited and developed our value system. Their drive and dedication serve as motivation for all employees to forge ahead and excel in their respective positions.'
  },
  // 关于我们-公司概览

  comOverview: {
    bannerTitle: 'OVERVIEW',
    textLeftUp: 'LSH Auto China, exclusively serving the premium automotive sector, has a presence across 87 cities.',
    textLeftDown: '',
    textRightNext: ',LSH Auto China offers a range of diversified products and services to cater to the varying needs of our customers.  Our business model covers the sale of new cars, pre-owned cars, car parts and accessories, as well as aftersales services, financing and insurance services, and related automotive services.',
    textRight: 'As a member of',
    textRightUrl: ' Lei Shing Hong Group',
    text: '',
    textBelong: '',
    heading: 'BRAND MISSION AND BRAND VALUES',
    headingInfo: 'Our mission: Build Trust.Deliver  Excellence. Always.',
    headingInfoNext: 'Our brand value:',
    missionList: [
      {
        id: 1,
        heading4: 'TRUST',
        headingDetail: 'Trust opens doors, breaks down barriers and builds long and rewarding relationships.',
        url: 'Pone.jpg',
        activeClass: 'icon icon-people'
      },
      {
        id: 2,
        heading4: 'INTEGRITY',
        headingDetail: 'Integrity encompasses honesty, responsibility and accountability. And it also represents respect for our customers and our corporation. Always let integrity govern our words and deeds. Only by doing this can we maintain good quality and gain trust from customers.',
        url: 'Ptwo.jpg',
        activeClass: 'icon icon-hand'
      },
      {
        id: 3,
        heading4: 'CUSTOMER RELEVANCE',
        headingDetail: 'Staying relevant with customers is key to a long-term relationship. It means engaging in conversations and knowing what others are doing. It also means constantly upgrading our knowledge, soft skills and our own expectations.',
        url: 'Pthree.jpg',
        activeClass: 'icon icon-help'
      },
      {
        id: 4,
        heading4: 'EXCELLENCE & INNOVATION',
        headingDetail: 'Excellence requires effort on many levels and in every aspect of our work. We keep learning with an open mindset, and adhere to innovative ideas and practices to become a better self and achieve a greater cause.',
        url: 'Pfour.jpg',
        activeClass: 'icon icon-list-up'
      },
      {
        id: 5,
        heading4: 'TEAMWORK & SOCIAL RESPONSIBILITY',
        headingDetail: 'Teamwork is the fuel that drives our success and builds our individual strength of character. we will continue to invest in the community we operate in and explore possible partners and worthwhile opportunities to make a difference in our community.',
        url: 'Pfive.jpg',
        activeClass: 'iconfont icon-2'
      }
    ],
    missionListMobile: [
      {
        heading4: 'TRUST',
        headingDetail: 'Trust opens doors, breaks down barriers and builds long and rewarding relationships.',
        url: 'Mone.jpg',
        activeClass: 'icon icon-people'
      },
      {
        heading4: 'INTEGRITY',
        headingDetail: 'Integrity encompasses honesty, responsibility and accountability. And it also represents respect for our customers and our corporation. Always let integrity govern our words and deeds. Only by doing this can we maintain good quality and gain trust from customers.',
        url: 'Mtwo.jpg',
        activeClass: 'icon icon-hand'
      },
      {
        heading4: 'CUSTOMER RELEVANCE',
        headingDetail: 'Staying relevant with customers is key to a long-term relationship. It means engaging in conversations and knowing what others are doing. It also means constantly upgrading our knowledge, soft skills and our own expectations.',
        url: 'Mthree.jpg',
        activeClass: 'icon icon-help'
      },
      {
        heading4: 'EXCELLENCE & INNOVATION',
        headingDetail: 'Excellence requires effort on many levels and in every aspect of our work. We keep learning with an open mindset, and adhere to innovative ideas and practices to become a better self and achieve a greater cause.',
        url: 'Mfour.jpg',
        activeClass: 'icon icon-list-up'
      },
      {
        heading4: 'TEAMWORK & SOCIAL RESPONSIBILITY',
        headingDetail: 'Teamwork is the fuel that drives our success and builds our individual strength of character. we will continue to invest in the community we operate in and explore possible partners and worthwhile opportunities to make a difference in our community.',
        url: 'Mfive.jpg',
        activeClass: 'iconfont icon-2'
      }
    ],
    slickList: [
      { id: 1, url: 'PMendOne.jpg' },
      { id: 2, url: 'PMendTwo.jpg' },
      { id: 3, url: 'PMendThree.jpg' },
      { id: 4, url: 'PMendFour.jpg' }
    ],
    yes: 'AN',
    customer: ' UNWAVERING COMMITMENT',
    notToMove: ' TO',
    promise: ' OUR CUSTOMERS',
    description: 'We are committed to providing comfortable and caring services and experiences. Our 17K+ employees are an embodiment of our service culture, as we strive to deliver personalized solutions with a unique service DNA.'
  },
  // cookile
  cookile: {
    name:"LSH Auto China and Cookie: To provide you with a better browsing experience, we use cookies. By clicking 'Agree' or continuing to browse this website you agree to our use of cookies. ",
    learnMore:"To learn more",
    agree:"Agree"
  },
  // 首页
  homePage: {
    name: 'LSH AUTO CHINA',
    namet: 'ONE OF THE LEADING PREMIUM AUTOMOBILE <br/> DEALER GROUPS IN MAINLAND CHINA',
    namedown: 'Scroll down',
    premium: '',
    title: 'PREMIUM AUTOMOTIVE RETAILING',
    description: 'LSH Auto China, exclusively serving the premium automotive sector, has a presence across 87 cities. We are committed to delivering diversified products and services to meet the varying demands of customers.',
    leftContent: 'Since entering China thirty years ago, LSH Auto China remains fully dedicated to delivering innovative products and services as well as providing customers with a comfortable and caring experience. For years, LSH Auto China has been ranked one of the Top Five Dealer Groups by the China Automobile Dealers Association.',
    leftContentTwo: '',
    Create: 'DRIVING',
    limousine: 'THE FUTURE OF LUXURY AUTOMOTIVE RETAIL',
    count: '21.8',
    noCount: 'K+',
    textCar: 'New cars sold',
    countAnimation: '188',
    textCity: 'Outlets (Including ',
    cityCenter: 'Convenient Service Satellites)',
    countNext: '80+',
    textNext: 'Cities',
    countEmployee: '1.6',
    employeeCount: 'K+',
    employeeText: 'Employees',
    closingDate: 'Data as of December 31, 2021',
    upAnimation: 'BRANDS PARTNERS',
    upAnimationTwo: '',
    upAnimationThree: '',
    centerUpAnimation: 'LSH Auto China has established long-term and stable partnerships with premium automotive brands such as Mercedes-Benz, Mercedes-AMG, Mercedes-Maybach, Mercedes-EQ and smart.',
    lookMore: 'READ MORE',
    readMore: 'READ MORE',
    luxuryCarBrand: 'Premium Auto Brands',
    newCar: 'New Cars',
    usedCar: 'Pre-Owned Cars',
    afterSaleService: 'Aftersales',
    financialServices: 'Financing & Insurance',
    news: 'News',
    viewAll: 'SEE ALL',
    queryMore: 'View more',
    ruralContentOne: ' LSH Auto China goes on another mission to earthquake struck city of Yushu, Qinghai ',
    ruralContentTwo: 'On 14 April 2010, a 7.1 magnitude earthquake struck Yushu, a city of Yushu Tibetan Autonomous Prefecture in Southern Qinghai Province, China. ',
    ruralContentThree: 'Many lives were lost and many injured and made homeless.',
    helpHenan: ' Rising up to a catastrophic flooding in Henan. ',
    helpHenanContent: "On 20 July this year, Henan province in China experienced extreme rainfall that measured over a year's worth....",
    newsTitle: ' LSH Auto China ranks among top 3 of the 2021 top 100 auto dealer groups in China by the China Automobile Dealers Association. ',
    newsDescription: 'On May 28, 2021, China Automobile Dealers Association (CADA) released the results of the 2021 Top 100 Auto Deal Groups in China at the 2021 China Auto Dealers Conference held in Wenzhou.',
    ourFootprints: 'OUR FOOTPRINT',
    ourFootprintsCon: 'LSH Auto China has developed a wide retail network that covers a total of 223 outlets (including convenient service satellites) across 87 cities.'
  },
  // 免责声明
  disclaimerCopyright: {
    bannerTitle: 'DISCLAIMER',
    disclaimer: 'DISCLAIMER AND COPYRIGHT',
    disclaimerNotice: 'The information contained in this website is provided on the basis of the current information available to or known by Lei Shing Hong Auto (China) Management Co. Ltd. (“LSH”). Whilst LSH endeavours to ensure the accuracy of such information, LSH shall:',
    disclaimerList: [
      {
        id: 1,
        detail: 'Reserve its right to modify this website at any time without notice;'
      },
      {
        id: 2,
        detail: 'Disclaim from making any guarantee of or accepting any liability for the completeness, accuracy or timeliness of such information or this website;'
      },
      {
        id: '3',
        detail: 'Accept no responsibility for the content of any third party website to which a hypertext link from this website exists (“Third Party Website”);'
      },
      {
        id: 4,
        detail: 'Any purpose relating to or in connection with compliance with any law, regulation, court order or direction of a competent authority;'
      },
      {
        id: '5',
        detail: 'Not be responsible for any errors, omissions or damages (including, without limitation, damages for loss of business or profit) arising in contract, tort or otherwise from the use of or inability to use such information, this website or Third Party.'
      }
    ],
    oneDetail: 'The Third Party Website is linked for convenience only and such link does not indicate any endorsement, recommendation or approval by LSH of such Third Party Website or the product/service provided in such Third Party Website.',
    twoDetail: 'Unless required by laws or expressly stated in this website, users of this website shall not take any of the information contained in this website as being advice or recommendation of LSH. Such information is provided on “as is” basis.',
    threeDetail: 'Under no circumstances should the use of such information or this website be construed as granting a licence or right to use any of the intellectual property rights displayed or embedded in such information or this website for any purpose. No person shall create or establish a hypertext link to this website without the written permission of LSH.',
    fourDetail: "All matters relating to users' access to and use of such information or this website shall be governed by the laws of the People's Republic of China."
  },
  // 隐私条款
  PrivacyClause: {
    bannerTitle: 'PRIVACY',
    privacyStatement: 'PRIVACY NOTICE',
    subContent: [
      {
        id: 1,
        subTitle: 'Important',
        detail: 'This Privacy Notice generally applies to our website and any of its webpages. Please read this Privacy Notice carefully before submitting or disclosing any information (including but not limited to personal data). By accessing this website or utilizing the features in this website, you are agreeing to the terms and conditions set out below.'
      },
      {
        id: 2,
        subTitle: 'Information Collection',
        detail: 'We collect and retain any information (including but not limited to personal data) submitted by you through our website or through any other way (such as emails). You can choose not to submit certain information, but then you might not be able to utilize some or all of the features in this website.'
      },
      {
        id: 3,
        subTitle: 'Use and Purpose',
        detail: 'We may use the information submitted by you for the following purposes:'
      }
    ],
    objectiveList: [
      {
        id: 21,
        detail: 'responding to your requests, processing your applications for services, customizing future services for you, improving our services, or communicating with you;'
      },
      {
        id: 22,
        detail: 'transferring, sharing or verifying the information with any of our group companies, service providers, business partners, agents or advisors;'
      },
      {
        id: 23,
        detail: 'conducting statistical analyses or improving overall accuracy or completeness;'
      },
      {
        id: 24,
        detail: 'any purpose relating to or in connection with compliance with any law, regulation, court order or direction of a competent authority;'
      },
      {
        id: 25,
        detail: 'any other purposes relating to or in connection with our business or dealings or the business or dealings of any of our group companies, service providers, business partners, agents, or advisors.'
      }
    ],
    subContentBottom: [
      {
        id: 31,
        subTitle: 'Security Measures',
        detail: 'Information submitted through our website is protected by Hypertext Transfer Protocol Secure (or, in short, HTTPS) encrypted communication and our website is certified by a leading provider of SSL certificate.'
      },
      {
        id: 32,
        subTitle: 'Retention',
        detail: 'Your personal data which you have submitted to us will be retained for a reasonable period after termination of the relevant enquiry, application, or service (whichever is later).'
      },
      {
        id: 33,
        subTitle: 'Access',
        detail: 'You have the right to request access to and correction of personal data about you held by us. If you wish to access or correct your personal data held by us, please send your written request to the contact email/address stated in the relevant webpage of the service which you have made enquiry, applied for or subscribed (as the case may be).'
      },
      {
        id: 43,
        subTitle: 'Limitation of Liability',
        detail: 'We do not guarantee the accuracy, completeness or reliability of the collected information and accept no liability (whether in tort or contract or otherwise) for any loss or damage arising from any inaccuracies, incompleteness or omissions. Further, as email communications may not be completely secured, we accept no liability for any damage suffered by you if you communicate with us by way of emails.'
      }
    ]
  },
  // 网站地图
  sitMap: {
    bannerTitle: 'SITEMAP',
    siteMapDate: [
      {
        id: 1,
        navName: 'ABOUT US',
        navProperty: [
          { id: 11, propertyName: 'Overview', href: '/aboutUs/overview' },
          { id: 12, propertyName: 'Our people', href: '/aboutUs/people' },
          { id: 13, propertyName: 'History', href: '/aboutUs/history' },
          { id: 14, propertyName: 'Awards', href: '/aboutUs/awards' }
        ]
      },
      {
        id: 2,
        navName: 'BUSINESSES',
        navProperty: [
          { id: 21, propertyName: 'Premium Auto Brands', href: '/business/premium-auto-brands' },
          { id: 22, propertyName: 'New Cars', href: '/business/new-car-sales' },
          { id: 23, propertyName: 'Pre-Owned Cars', href: '/business/used-car-sales' },
          { id: 24, propertyName: 'Aftersales', href: '/business/aftersales-services' },
          { id: 25, propertyName: 'Financing & Insurance', href: '/business/financing-and-insurance' }
        ]
      },
      { id: 3, navName: 'NETWORK', href: '/network' },
      { id: 4, navName: 'CORPORATE RESPONSIBILITY', href: '/responsibility' },
      { id: 5, navName: 'CAREERS', href: '/career' },
      { id: 6, navName: 'NEWS', href: '/news' },
      { id: 7, navName: 'CONTACT', href: '/contact' }
    ]
  }
}
